import { render } from "./EndpointConfig.vue?vue&type=template&id=1f560e4c&scoped=true&lang=pug"
import script from "./EndpointConfig.vue?vue&type=script&lang=js"
export * from "./EndpointConfig.vue?vue&type=script&lang=js"

import "./EndpointConfig.vue?vue&type=style&index=0&id=1f560e4c&lang=scss"
import "./EndpointConfig.vue?vue&type=style&index=1&id=1f560e4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f560e4c"]])

export default __exports__